var system = {};
module['exports'] = system;
system.mimeTypes = require("./mimeTypes");